import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { ContentState, EditorState } from "draft-js";
import React, { useEffect, useState } from "react";
import useLocale from "../../../hooks/useLocale";
import CustomEditor from "../../components/Editor";
import htmlToDraft from "html-to-draftjs";

function ViewMoreInfoDialog({ open, close, info }) {
  const { t } = useLocale();
  const [editorState, setEditorState] = useState("");

  useEffect(() => {
    setEditorState(() => {
      let contentBlock = null;
      if (info) {
        contentBlock = htmlToDraft(info);
      }
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        return newEditorState;
      }
    });
  }, [info]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <CustomEditor toolbarHidden readOnly editorState={editorState} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary" autoFocus>
          {t("Ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ViewMoreInfoDialog;
